module.exports = __webpack_public_path__ + "img/login-cctv.306a08d4.png";